
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premier-advisor/[slug]",
      function () {
        return require("private-next-pages/premier-advisor/[slug]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premier-advisor/[slug]"])
      });
    }
  